const _ = require('lodash');

var TRUTHY_VALUES = [
    'true',
    '1',
    'yes',
    'enabled',
    'enable',
    'active',
    1,
    true
];

_.mixin({
    /**
     *
     * @param string
     * @returns {string}
     */
    capitalize: function (string) {
        return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
    },
    /**
     * https://github.com/kvz/phpjs/blob/master/functions/url/urlencode.js
     * @param url
     * @return {string} encoded url
     */
    urlencode: function (str) {
        str = (str + '').toString();
        // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
        // PHP behavior, you would need to add '.replace(/~/g, '%7E');' to the following.
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    checkIfTrue: function (value) {
        return TRUTHY_VALUES.indexOf(value) >= 0;
    }

});


// WEBPACK FOOTER //
// ./app/scripts/util/mixin.js